import ActionButton from 'components/ActionButton';
import AssignInventoryItemsModal from 'components/AssignInventoryItemsModal';
import Currency from 'components/Currency/Currency';
import { Loading } from 'components/loading/Loading';
import CustomLink from 'components/TableLink';
import { tableStyles } from 'css/tableStyles';
import _ from 'lodash';
import React, { useMemo, useState } from 'react';
import { useEffect } from 'react';
import DataTable from 'components/DataTable';
import { fetchInventoryItems } from 'services';
import { getPageLimit, updatePageLimit } from 'utils';
import styles from '../../inventory-items/detail/index.module.scss';

const filters: { [p: string]: any; page: number } = {
  page: 0,
};


const TagInventoryItems = props => {
  const [addModalOpen, setAddModalOpen] = useState<boolean>(false);
  const [inventoryItems, setInventoryItems] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const {
    tagDetails,
  } = props;
  
  useEffect(()=>{
    fetchListData();
  },[]);

  const columns = useMemo(() => [
    {
      name: 'ItemID',
      selector: 'objectId',
      sortable: false,
      width: '150px',
      // eslint-disable-next-line react/display-name
      cell: row => (
        <div>
          <CustomLink
            text={row.objectId}
            linkTo={`/inventory-items/${row.objectId}`}
          />
          {/* {getWarningIcon(row)} */}
        </div>
      ),
    },
    {
      name: 'Item Name',
      selector: 'name',
      sortable: false,
    },
    {
      name: 'Category',
      selector: 'category.description',
      sortable: false,
    },
    {
      name: 'Price',
      selector: 'price',
      width: '100px',
      sortable: false,
      // eslint-disable-next-line react/display-name
      format: (row) => (<Currency amount={parseFloat(row.price.toFixed(2))} default={'-'} />),
    },
    {
      name: 'Unit',
      selector: 'unit',
      sortable: false,
      width: '100px',
      // eslint-disable-next-line react/display-name
      cell: row => (
        <div>{row.unit?.description || ''}</div>
      ),
    },
    {
      name: 'Active',
      selector: 'active',
      sortable: false,
      width: '100px',
      // eslint-disable-next-line react/display-name
      cell: row => {
        if (typeof row.active !== 'undefined') {
          return <div>{row.active.toString()}</div>;
        } else {
          return <div>{'N/A'}</div>;
        }
      },
    }], []);

  const fetchListData = async ()=>{
    const { page,...rest } = filters;
    try {
      setLoading(true);
      const res = await fetchInventoryItems({ 
        filter: { tag: tagDetails.objectId ,...rest },
        page,
        limit:getPageLimit(),
      });
      setInventoryItems(res);
    } catch(e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  };

  const onChangePage = (page: number) => {
    filters.page = page - 1;
    fetchListData();
  };

  const onChangeRowsPerPage = (rowsPerPage: number, currentPage: number) => {
    filters.limit = rowsPerPage;
    updatePageLimit(rowsPerPage);
    onChangePage(currentPage);
  };

  const toggleModal = () => setAddModalOpen(!addModalOpen);

  if (loading) return <Loading />;

  return (
    <>
      {addModalOpen && (
        <AssignInventoryItemsModal
          itemId={tagDetails.objectId}
          onSuccess={fetchListData}
          toggleModal={toggleModal}
        />
      )}
      <div className={styles['related-items-container']}>
        <div className={styles['section-header']}>
          <div className={styles['section-heading']}>Inventory Items</div>
          <ActionButton
            text={<>Inventory Item <span className={'ml-3'}>+</span></>}
            active={true}
            isLoading={false}
            onClick={() => setAddModalOpen(true)}
          />
        </div>
        <DataTable
          columns={columns}
          noHeader={true}
          data={inventoryItems?.items}
          highlightOnHover={true}
          customStyles={tableStyles}
          pagination={true}
          paginationServer={true}
          paginationPerPage={getPageLimit()}
          paginationDefaultPage={(filters.page || 0) + 1}
          paginationTotalRows={inventoryItems?.total}
          paginationRowsPerPageOptions={[50, 100, 200]}
          onChangePage={onChangePage}
          onChangeRowsPerPage={onChangeRowsPerPage}
        />
      </div>
    </>
  );
};

export default TagInventoryItems;